import { computed } from '@vue/composition-api';
import { DialogInstance, DialogOptions } from 'tdesign-vue';
import { i18n_t } from '@/locales/i18n';
import store from '@/renderer/store';
import { getUserRole } from '@/renderer/scripts/utils/UserRole';
import { getExpiredDays } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import meeting from '@/renderer/scripts/utils/meeting';
import { IS_OPEN_IN_APPLE, IS_PRIVATE } from '@/common/constant/platform';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';
import ipc from '@/renderer/scripts/utils/ipc';

import user from '../utils/user';

let dialog: DialogInstance;
type optionData = {
  isCollaboration?: boolean;
  isCollectFile?: boolean;
  collectFileRole?: string;
  index?: number;
  collaborationRole?: string;
};
export function closeDialog() {
  if (window.location.pathname.includes('teamExpired')) return;
  if (dialog && dialog.hide) {
    dialog.hide();
  }
}
export const checkIfMobileStyle = () => {
  const { isMobileStyle, isInWeMeetApp, isMobile } = store.getters;
  if (isMobileStyle) {
    closeDialog();
    const dialogOption: DialogOptions = {
      header: '',
      body: '',
    };
    if (isMobile) {
      dialogOption.header = i18n_t('需切换设备');
      dialogOption.body = i18n_t('移动端暂不支持该功能，请前往电脑端使用');
    } else if (isInWeMeetApp) {
      dialogOption.header = i18n_t('需调节窗口大小');
      if (meeting.wemeetAppPosition === 1) {
        // 独立弹出
        dialogOption.body = i18n_t('该功能无法在该分辨率正常使用，请调大窗口大小');
        dialogOption.confirmBtn = i18n_t('我知道了');
        dialogOption.cancelBtn = null;
      } else {
        // 主界面或侧边栏
        dialogOption.body = i18n_t('该功能无法在该分辨率正常使用，请调大窗口大小或独立弹出使用');
        dialogOption.confirmBtn = i18n_t('独立弹出');
        dialogOption.cancelBtn = i18n_t('取消');
      }
    } else if (isMobileStyle) {
      dialogOption.header = i18n_t('需调节浏览器分辨率');
      dialogOption.body = i18n_t('该功能无法在该分辨率使用，请调大浏览器分辨率');
    }
    dialog = CustomDialog.confirm({
      width: '320px',
      closeBtn: false,
      // @ts-ignore
      cancelBtn: null,
      closeOnEscKeydown: false,
      closeOnOverlayClick: false,
      ...dialogOption,
      async onConfirm() {
        // 非独立窗口时才切换到独立窗口
        if (isInWeMeetApp && !isMobile && meeting.wemeetAppPosition !== 1) {
          meeting.changeWebAppPosition({
            position: 1,
          });
        }
        if (dialog?.hide) {
          dialog.hide();
        }
      },
    });
  }
  return store.getters.isMobileStyle;
};
export enum PAY_SOURCE {
  CREATE_SHARE_LINK = 'CREATE_SHARE_LINK',
  OPEN_SHARE_LINK_LIMIT = 'OPEN_SHARE_LINK_LIMIT',
  DYNAMIC_DRAWER = 'DYNAMIC_DRAWER',
  HISTORY_DRAWER = 'HISTORY_DRAWER',
  UPLOAD_FILES = 'UPLOAD_FILES',
  SIDEBAR_ADCORNER = 'SIDEBAR_ADCORNER',
  CREATE_SHARE_GROUP_LIMIT = 'CREATE_SHARE_GROUP_LIMIT',
  ORG_EXPIRED = 'ORG_EXPIRED',
  DOWNLOAD_FILE_TRAFFIC = 'DOWNLOAD_FILE_TRAFFIC',
  USER_LIMIT = 'USER_LIMIT',
}
const PAY_SOURCE_MAP = {
  // 创建分享外链
  CREATE_SHARE_LINK: 'sharelink_insufficient_popup',
  // 打开分享外链下载/预览次数限制
  OPEN_SHARE_LINK_LIMIT: 'sharelink_insufficient_popup',
  // 上传文件弹窗
  UPLOAD_FILES: 'space_insufficient_popup',
  // 创建协作群组限制
  CREATE_SHARE_GROUP_LIMIT: 'group_insufficient_popup',
  // 企业过期的弹窗
  ORG_EXPIRED: 'org_expired',
  // 下载文件的流量不足
  DOWNLOAD_FILE_TRAFFIC: 'download_file_traffic',
  // 可用账户不足
  USER_LIMIT: 'user_limit',

  // 下面三个属于不需要弹窗的
  DYNAMIC_DRAWER: 'details_activities_tips',
  // 协作动态购买
  HISTORY_DRAWER: 'details_history_tips',
  // 历史版本购买
  SIDEBAR_ADCORNER: 'personal_buy', // 侧边栏广告位
};

export async function openTeamPayDialog(paySource: PAY_SOURCE, options?: optionData) {
  if (store.getters.isVistorLogined === false) {
    await store.dispatch('GetOrgInfo', store.getters.orgId);
  }
  const { editionFlag, expireTime, orgId, orgChannelEdition, instanceId } = store.getters;
  // 未升级的体验版
  const channelNotUpdate = computed(() => {
    const { orgChannel, channelUpdated } = store.getters;
    return orgChannel && !channelUpdated;
  });
  // 计算过期天数
  const expiredDay = getExpiredDays(expireTime);
  const absExpiredDay = Math.abs(expiredDay);
  const dialogOption: DialogOptions = {
    header: '',
    body: '',
  };
  let showDialog = true;
  let userRole = ''; // 上传文件空间不足 | 创建协作空间数量不够 时才会赋值
  switch (paySource) {
    case PAY_SOURCE.CREATE_SHARE_LINK: {
      dialogOption.header = i18n_t('可创建外链不足');
      dialogOption.body = i18n_t('最多可同时创建5个安全外链，购买企业版，安全外链数量不限');
      dialogOption.confirmBtn = i18n_t('购买');
      break;
    }
    case PAY_SOURCE.OPEN_SHARE_LINK_LIMIT: {
      dialogOption.header = i18n_t('升级企业版可用');
      dialogOption.body = i18n_t('该功能升级企业版后可用');
      dialogOption.confirmBtn = i18n_t('升级');
      break;
    }
    case PAY_SOURCE.UPLOAD_FILES: {
      dialogOption.header = i18n_t('空间不足');
      if (store.getters.isVistorLogined) {
        // 收集文件空间不足应该通知发起者
        if (options?.isCollectFile) {
          dialogOption.body = i18n_t('空间存储已满，文件无法上传，请联系任务发起者处理');
          dialogOption.confirmBtn = i18n_t('确定');
        } else {
          dialogOption.body = i18n_t('空间存储已满，建议购买企业版，拥有更大使用空间');
          dialogOption.confirmBtn = i18n_t('购买');
        }
      } else {
        userRole = store.getters.userRole || (await getUserRole());
        // 协作群组空间不足应该是通知群主和收集文件空间不足应该通知发起者
        if (options?.isCollaboration || options?.isCollectFile) {
          if ([options.collaborationRole, options?.collectFileRole].includes('isOwner') && userRole !== 'User') {
            if (IS_PRIVATE) {
              // 私有化下的提示文案
              dialogOption.body = i18n_t('空间存储已满，请前往【管理中心】分配更多空间容量');
            } else {
              dialogOption.body = i18n_t('空间存储已满，点击进行扩容');
              dialogOption.confirmBtn = i18n_t('购买');
            }
          } else if ([options.collaborationRole, options?.collectFileRole].includes('isOwner') && userRole === 'User') {
            dialogOption.body = i18n_t('空间存储已满，请联系管理员扩容');
          } else {
            if (options?.isCollaboration) {
              dialogOption.body = i18n_t('空间存储已满，请联系群主扩容');
            } else if (options?.isCollectFile) {
              dialogOption.body = i18n_t('空间存储已满，文件无法上传，请联系任务发起者处理');
            }
          }
          dialogOption.confirmBtn = dialogOption.confirmBtn || i18n_t('确定');
          break;
        }

        // 会议侧体验版的文案不一样
        if (channelNotUpdate.value) {
          if (userRole !== 'User') {
            if (IS_OPEN_IN_APPLE) {
              // 苹果的操作系统不允许直接跳转至续费页
              dialogOption.body = i18n_t('当前空间不足，无法进该操作，请进行文件清理或者前往网页版进行管理');
              dialogOption.confirmBtn = i18n_t('打开网页版');
            } else {
              dialogOption.body = i18n_t('当前空间不足，无法进该操作，请进行文件清理或者升级扩容');
              dialogOption.confirmBtn = i18n_t('扩容升级');
            }
          } else {
            dialogOption.body = i18n_t('空间存储不足，无法进行文件上传同步操作，请联系管理员进行升级');
            dialogOption.confirmBtn = i18n_t('确定');
          }
          break;
        }
        // 不同身份或者企业上传文件空间不足的提示
        if (editionFlag !== 'personal' && userRole === 'User') {
          dialogOption.body = i18n_t('空间存储已满，请联系管理员扩容');
          dialogOption.confirmBtn = i18n_t('确定');
        } else if (editionFlag === 'enterprise' && userRole !== 'User') {
          if (IS_PRIVATE) {
            // 私有化下的提示文案
            dialogOption.body = i18n_t('空间存储已满，请前往【管理中心】分配更多空间容量');
            dialogOption.confirmBtn = i18n_t('确定');
          } else {
            dialogOption.body = i18n_t('空间存储已满，点击进行扩容');
            dialogOption.confirmBtn = i18n_t('购买');
          }
        } else {
          dialogOption.body = i18n_t('空间存储已满，建议购买企业版，拥有更大使用空间');
          dialogOption.confirmBtn = i18n_t('购买');
        }
      }
      break;
    }
    case PAY_SOURCE.CREATE_SHARE_GROUP_LIMIT: {
      userRole = store.getters.userRole || (await getUserRole());
      dialogOption.header = i18n_t('可创建群组不足');
      if (editionFlag === 'personal') {
        dialogOption.body = i18n_t('最多可以创建5个群组，购买企业版，创建群组无限制');
        dialogOption.confirmBtn = i18n_t('购买');
      } else if (editionFlag === 'team') {
        if (userRole === 'User') {
          dialogOption.body = i18n_t('团队版最多可创建300个群组，创建更多群组请联系管理员升级到企业版');
          dialogOption.confirmBtn = i18n_t('确定');
        } else {
          dialogOption.body = i18n_t('团队版最多可创建300个群组，创建更多群组可升级到企业版');
          dialogOption.confirmBtn = i18n_t('购买');
        }
      } else {
        // 兜底处理-避免以后企业版的群组创建出现bug
        dialogOption.body = i18n_t('当前群组创建数量已达上限，可前往腾讯云提工单解锁更大数额');
        dialogOption.confirmBtn = i18n_t('确定');
      }
      break;
    }
    case PAY_SOURCE.ORG_EXPIRED: {
      userRole = store.getters.userRole || (await getUserRole());
      dialogOption.header = editionFlag === 'team' ? i18n_t('团队已过期') : i18n_t('企业版已过期');
      const renew = IS_OPEN_IN_APPLE ? i18n_t('处理') : i18n_t('Special.续费');
      reporter.report('value_added', {
        use_time_show: 'use_time_expired_fixed_popup',
      });
      /**
       * 未升级的渠道版过期 统一文案
       * 【注意】ios里不能出现“续费”字样
       * */
      if (channelNotUpdate.value) {
        if (userRole !== 'User') {
          if (absExpiredDay < 30) {
            const renewText = IS_OPEN_IN_APPLE ? '' : i18n_t('，请马上续费');
            dialogOption.body = i18n_t(
              '您的企业网盘已过期{absExpiredDay}天{renewText}。（若到期30天及以上未续期，数据将会被销毁且不可恢复）',
              {
                absExpiredDay,
                renewText,
              },
            );
            dialogOption.confirmBtn = IS_OPEN_IN_APPLE ? i18n_t('查看更多扩容方案') : i18n_t('续费');
          } else {
            dialogOption.body = i18n_t(
              '您的企业网盘已过期{absExpiredDay}天，由于到期超出30天及以上未续期，数据已被销毁且不可恢复',
              {
                absExpiredDay,
              },
            );
            dialogOption.cancelBtn = i18n_t('知道了');
            dialogOption.confirmBtn = i18n_t('前往新购');
          }
        } else {
          dialogOption.body = i18n_t('当前版本已过期{absExpiredDay}天，无法进行操作，请联系超级管理员{renew}', {
            absExpiredDay,
            renew,
          });
          dialogOption.cancelBtn = i18n_t('知道了');
          dialogOption.confirmBtn = null;
        }
        break;
      }
      if (userRole === 'User') {
        // 非超管只需显示退出登录即可
        dialogOption.body = i18n_t('当前{slot1}已过期{absExpiredDay}天，无法进行操作，请联系管理员{renew}', {
          slot1: editionFlag === 'team' ? i18n_t('团队') : i18n_t('企业版'),
          absExpiredDay,
          renew,
        });
        dialogOption.confirmBtn = null;
      } else if (absExpiredDay > 30 && editionFlag === 'enterprise') {
        // 企业版超30天无需区分超管和非超管
        dialogOption.body = i18n_t('当前企业版已过期超过30天，企业空间已被回收，请重新注册使用');
        dialogOption.confirmBtn = i18n_t('购买企业版');
      } else {
        // 超管企业版30天以内或团队版可续费
        dialogOption.body = i18n_t('当前{slot1}已过期{absExpiredDay}天，无法进行操作，请及时{renew}', {
          slot1: editionFlag === 'team' ? i18n_t('团队') : i18n_t('企业版'),
          absExpiredDay,
          renew,
        });
        dialogOption.confirmBtn = renew;
      }
      dialogOption.cancelBtn = i18n_t('退出登录');
      break;
    }
    case PAY_SOURCE.DOWNLOAD_FILE_TRAFFIC: {
      reporter.report('value_added', {
        flow_show: 'upload_copy_file_flow_popup',
      });
      dialogOption.header = i18n_t('流量耗尽');
      if (options?.isCollaboration && options?.collaborationRole !== 'isOwner') {
        dialogOption.body = i18n_t('当前流量耗尽，无法进行该操作，请联系群主进行升级');
        dialogOption.confirmBtn = i18n_t('确定');
        break;
      }
      userRole = store.getters.userRole || (await getUserRole());
      if (userRole === 'User') {
        dialogOption.body = i18n_t('当前流量耗尽，无法进行该操作，请联系管理员进行升级');
        dialogOption.confirmBtn = i18n_t('确定');
        break;
      }
      if (channelNotUpdate.value && IS_OPEN_IN_APPLE) {
        if (userRole !== 'User') {
          dialogOption.body = i18n_t('当前流量耗尽，无法进行该操作，请前往网页版进行管理');
          dialogOption.confirmBtn = i18n_t('打开网页版');
        }
      } else {
        dialogOption.body = i18n_t('当前流量耗尽，无法进行该操作，请进行升级扩容');
        dialogOption.confirmBtn = i18n_t('扩容升级');
      }
      break;
    }
    case PAY_SOURCE.USER_LIMIT: {
      reporter.report('value_added', {
        user_number_show: 'not_enough_use_number_popup',
      });
      dialogOption.header = i18n_t('企业成员剩余人数不足');
      if (channelNotUpdate.value && IS_OPEN_IN_APPLE) {
        dialogOption.body = i18n_t('企业人员数量已满，无法添加新成员，可前往网页版进行管理');
        dialogOption.confirmBtn = i18n_t('打开网页版');
      } else {
        dialogOption.body = i18n_t('企业人员数量已满，无法添加新成员，请及时扩容');
        dialogOption.confirmBtn = i18n_t('扩容');
      }
      break;
    }
    // 不需要弹窗的直接上报并打开购买页即可
    default:
      showDialog = false;
      break;
  }
  reporter.report('pay', {
    pay_source_show: PAY_SOURCE_MAP[paySource],
  });
  if (showDialog) {
    if (dialog && dialog.destroy) dialog.destroy();
    dialog = CustomDialog.confirm({
      theme: 'info',
      width: '500px',
      closeBtn: false,
      closeOnEscKeydown: false,
      closeOnOverlayClick: false,
      ...dialogOption,
      async onConfirm() {
        // 团队续费以及企业版续费不关闭弹窗
        if (dialog?.hide && ![PAY_SOURCE.ORG_EXPIRED].includes(paySource)) {
          dialog.hide();
        }
        if (IS_PRIVATE) return;
        if (options?.isCollaboration && options.collaborationRole !== 'isOwner') return;
        if (checkIfMobileStyle()) return;
        store.commit('setPaySource', PAY_SOURCE_MAP[paySource]);
        reporter.report('pay', {
          pay_source_pay: PAY_SOURCE_MAP[paySource],
        });
        if ([PAY_SOURCE.DOWNLOAD_FILE_TRAFFIC].includes(paySource)) {
          reporter.report('value_added', {
            flow_click: 'upload_copy_file_flow_popup',
          });
        } else if ([PAY_SOURCE.UPLOAD_FILES, PAY_SOURCE.CREATE_SHARE_GROUP_LIMIT].includes(paySource)) {
          const str = options?.isCollaboration ? 'groups_upload_copy_fixed_popup' : 'upload_copy_file_fixed_popup';
          reporter.report('value_added', {
            space_click: str,
          });
        } else if ([PAY_SOURCE.USER_LIMIT].includes(paySource)) {
          reporter.report('value_added', {
            user_number_click: 'not_enough_use_number_popup',
          });
        }
        // 扩容和升级dialog逻辑
        if (
          [
            PAY_SOURCE.UPLOAD_FILES,
            PAY_SOURCE.CREATE_SHARE_GROUP_LIMIT,
            PAY_SOURCE.DOWNLOAD_FILE_TRAFFIC,
            PAY_SOURCE.USER_LIMIT,
          ].includes(paySource)
        ) {
          // 团队版和企业版的普通成员都不支持扩容和升级
          if (userRole === 'User') return;
          if (channelNotUpdate.value) {
            dispatchRouter(`${CONSTANT_URL.channelBuyUrl}&orgId=${orgId}&instanceId=${instanceId}`);
            return;
          }
          // 企业版空间扩容和升级跳转至控制台购买页面
          if (editionFlag === 'enterprise') {
            // 如果是企业版的群组不足 跳工单页
            if (paySource === PAY_SOURCE.CREATE_SHARE_GROUP_LIMIT) {
              dispatchRouter(CONSTANT_URL.consoleBillUrl);
            } else {
              dispatchRouter(CONSTANT_URL.consoleManagementUrl);
            }
          } else {
            // 个人版和团队版升级和扩容需跳转至企业版购买
            dispatchRouter(CONSTANT_URL.purchaseUrl);
          }
          return;
        }
        // 续费dialog逻辑
        if ([PAY_SOURCE.ORG_EXPIRED].includes(paySource)) {
          reporter.report('value_added', {
            use_time_click: 'use_time_expired_fixed_popup',
          });
          // 企业过期三十天直接去购买页，普通用户关闭弹窗即可 不去购买页
          if (absExpiredDay > 30) {
            if (userRole === 'User') return;
            dispatchRouter(CONSTANT_URL.purchaseUrl);
            return;
          }
          if (userRole === 'User') {
            user.signOut();
            return;
          }
          if (channelNotUpdate.value) {
            dispatchRouter(`${CONSTANT_URL.channelBuyUrl}&orgId=${orgId}&instanceId=${instanceId}`);
            return;
          }
          if (editionFlag === 'team') {
            // 团队版续费仍需打开米大师弹窗
            store.commit('setTeamPay', {
              show: true,
              isNew: false,
            });
          } else if (absExpiredDay <= 30 && editionFlag === 'enterprise') {
            // 企业版过期30以内续费跳转至 控制台购买页面
            dispatchRouter(CONSTANT_URL.consoleManagementUrl);
          } else {
            // 企业过期30天后续费直接打开企业版购买页面
            dispatchRouter(CONSTANT_URL.purchaseUrl);
          }
          return;
        }
        if ([PAY_SOURCE.CREATE_SHARE_LINK, PAY_SOURCE.OPEN_SHARE_LINK_LIMIT].includes(paySource)) {
          // 对于创建链接弹窗 和外链分享受限直接跳企业版购买
          dispatchRouter(CONSTANT_URL.purchaseUrl);
        }
      },
      onCancel() {
        if ([PAY_SOURCE.ORG_EXPIRED].includes(paySource)) {
          user.signOut();
        }
      },
    });
  } else {
    if (checkIfMobileStyle()) return;
    reporter.report('pay', {
      pay_source_pay: PAY_SOURCE_MAP[paySource],
    });
    const paysource = PAY_SOURCE_MAP[paySource]; // 为 ADVANCE_GUIDE 时是 string[] 类型
    store.commit('setPaySource', typeof options?.index !== 'undefined' ? paysource[options?.index] : paysource);
    if (channelNotUpdate.value) {
      dispatchRouter(`${CONSTANT_URL.channelBuyUrl}&orgId=${orgId}&instanceId=${instanceId}`);
      return;
    }
    if (editionFlag === 'personal') {
      dispatchRouter(CONSTANT_URL.buyUrl);
    } else if (editionFlag === 'team') {
      store.commit('setTeamPay', {
        show: true,
        isNew: false,
      });
    } else {
      dispatchRouter(CONSTANT_URL.consoleManagementUrl);
    }
  }
}

export const openJumpToWorkbenchDialog = (routeName: 'personalSpace' | 'teamSpace' | string) => {
  const messageMap: Record<string, string> = {
    personalSpace: i18n_t('个人空间已被关闭，即将自动跳转至工作台'),
    teamSpace: i18n_t('企业空间已被删除，即将自动跳转至工作台'),
  };
  const message = messageMap[routeName] || i18n_t('当前空间已被删除，即将自动跳转至工作台');
  let backwards = 3;
  let timer: number | undefined = window.setInterval(() => {
    backwards -= 1;
    if (backwards === 0) {
      dispatchRouter({
        name: 'workbench',
      }).then(() => {
        if (dialog.hide) {
          dialog.hide();
        }
      });
      window.clearInterval(timer);
      timer = undefined;
    }
  }, 1000);
  const dialog = CustomDialog.confirm({
    theme: 'danger',
    header: i18n_t('错误'),
    default: message,
    confirmBtn: i18n_t('立即跳转'),
    cancelBtn: null,
    closeBtn: false,
    closeOnEscKeydown: false,
    closeOnOverlayClick: false,
    onConfirm: () => {
      dispatchRouter({
        name: 'workbench',
      }).then(() => {
        if (dialog.hide) {
          dialog.hide();
        }
      });
    },
  });
  if (routeName === 'teamSpace') {
    ipc.emit(ipc.RENDERER_EVENTS_MAP.TEAM_TREE_REFRESH, { silentLoading: true });
  }
};
